// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tA4S","left":"styles_left__29kVB","desktopActions":"styles_desktopActions__3IQyz","title":"styles_title__3rYNd"};